import React, { Fragment, useContext, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import ModalOverLay from './component/ModalOverLay';
import classNames from 'classnames/bind';
import styles from './App.module.scss';
import './App.css';

import EmptyLayout from './Layouts/EmptyLayout';
import { publicRouters } from './routes/routes';
import { useLoading } from './component/Context/LoadingProvider';
import Toast from './component/Toast';
import SideBar from './Layouts/components/SideBar';
import useMeta from './hooks/useMeta';
import { MusicContext } from './component/Context/MusicProvider';
import ReactAudioPlayer from 'react-audio-player';

const cx = classNames.bind(styles);

function App() {
  const { loadingCount } = useLoading();
  const { audioRef, currentSong, playNextSong } = useContext(MusicContext);

  useMeta({
    title: 'Ngô Gia Quyến - Blog Cá Nhân',
    description: 'Nơi chia sẻ kiến thức về lập trình, công nghệ, và nhiều hơn thế.',
    keywords: 'lập trình, công nghệ, blog, Ngô Gia Quyến, Fullstack Developer',
    author: 'Ngô Gia Quyến',
    url: 'https://ngogiaquyen.id.vn',
  });

  return (
    <Router>
      <div className="App">
        {/* <ScrollRestoration /> */}
        <SideBar />

        {/* Ẩn trình phát khi không có bài hát nào được chọn */}
        <div className={cx('audio-container', { hidden: !currentSong })}>
          <ReactAudioPlayer ref={audioRef} src={currentSong} controls autoPlay onEnded={playNextSong} />
        </div>

        <Routes>
          {publicRouters.map((route, index) => {
            const Page = route.component;
            let Layout = EmptyLayout;

            if (route.layout) {
              Layout = route.layout;
            } else {
              Layout = Fragment;
            }

            return (
              <Route
                key={index}
                path={route.path}
                element={
                  <Layout>
                    <Page {...route.props} />
                  </Layout>
                }
              />
            );
          })}
        </Routes>
        <ModalOverLay />
        <Toast />
      </div>
    </Router>
  );
}

export default App;
